import { useEffect, useRef } from 'react';
import { styled } from '@mui/material';
import { FileItem, getFileUrl, getMediaType } from 'src/utils/fileUploadUtils';

interface MediaRendererProps {
  file: FileItem;
  onClick?: () => void;
}

const MediaRenderer = ({ file, onClick }: MediaRendererProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const mediaUrl = getFileUrl(file.value);
  const mimeType = getMediaType(file.value);
  const isVideo = mimeType.startsWith('video/');

  // 수정 시에만 video reload 적용
  useEffect(() => {
    const video = videoRef.current;
    if (video && isVideo && typeof file.value === 'string') {
      video.load();
    }
  }, [mediaUrl, isVideo, file.value]);

  if (!mediaUrl) return null;

  if (isVideo) {
    return (
      <MediaContainer onClick={onClick}>
        <StyledVideo ref={videoRef} key={file.id} draggable={false} playsInline autoPlay loop>
          <source src={mediaUrl} type={mimeType} />
        </StyledVideo>
      </MediaContainer>
    );
  }

  return (
    <MediaContainer onClick={onClick}>
      <StyledImage src={mediaUrl} alt="preview" />
    </MediaContainer>
  );
};

export default MediaRenderer;

const MediaContainer = styled('div')(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
}));

const StyledVideo = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
});
const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
});
